import React, { useEffect, useMemo, useState } from "react";

const HomepageVideoSlider = () => {
  const [videos, setVideos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showSection, setShowSection] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        setLoading(true);
        setError("");

        const res = await fetch(
          "https://eventscons.com/eventbackendnew/api/homepage-get-video-link"
        );
        const result = await res.json();

        if (result?.status && result?.data) {
          const videoLinks = result?.data?.homepage_video_link || [];
          const bannerBottomStatus = result?.data?.bannerBottomStatus;

          setShowSection(!!bannerBottomStatus);

          if (videoLinks.length > 0) {
            setVideos(videoLinks);
            setCurrentIndex(0);
          } else {
            setError("No video links found");
          }
        } else {
          setError("Invalid API response");
        }
      } catch (err) {
        setError("Failed to fetch videos");
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const getEmbedUrl = (videoUrl) => {
    if (!videoUrl) return "";

    try {
      const url = new URL(videoUrl);

      if (url.hostname === "youtu.be") {
        const videoId = url.pathname.replace("/", "");
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&rel=0&playsinline=1`;
      }

      if (url.hostname.includes("youtube.com") && url.searchParams.get("v")) {
        const videoId = url.searchParams.get("v");
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&rel=0&playsinline=1`;
      }

      if (
        url.hostname.includes("youtube.com") &&
        url.pathname.includes("/shorts/")
      ) {
        const videoId = url.pathname.split("/shorts/")[1];
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1&rel=0&playsinline=1`;
      }

      return "";
    } catch {
      return "";
    }
  };

  const currentVideo = useMemo(() => {
    return videos[currentIndex] || "";
  }, [videos, currentIndex]);

  const nextSlide = () => {
    if (videos.length <= 1) return;
    setCurrentIndex((prev) => (prev + 1) % videos.length);
  };

  const prevSlide = () => {
    if (videos.length <= 1) return;
    setCurrentIndex((prev) => (prev - 1 + videos.length) % videos.length);
  };

  if (!loading && !showSection) {
    return null;
  }

  return (
    <section
      style={{
        width: "100%",
        padding: "30px 0",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "1200px",
          height: "500px",
          margin: "0 auto",
          position: "relative",
          overflow: "hidden",
          borderRadius: "20px",
          background: "#000",
        }}
      >
        {loading ? (
          <div
            style={{
              color: "#fff",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            Loading video...
          </div>
        ) : error ? (
          <div
            style={{
              color: "red",
              background: "#fff",
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {error}
          </div>
        ) : (
          <>
            <iframe
              key={currentIndex}
              src={getEmbedUrl(currentVideo)}
              title={`Homepage Video ${currentIndex + 1}`}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                width: "100%",
                height: "675px",
                transform: "translate(-50%, -50%)",
                border: "none",
                zIndex: 1,
              }}
            />

            {videos.length > 1 && (
              <>
                <button
                  type="button"
                  onClick={prevSlide}
                  aria-label="Previous video"
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "15px",
                    transform: "translateY(-50%)",
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    border: "none",
                    background: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    fontSize: "20px",
                    cursor: "pointer",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ‹
                </button>

                <button
                  type="button"
                  onClick={nextSlide}
                  aria-label="Next video"
                  style={{
                    position: "absolute",
                    top: "50%",
                    right: "15px",
                    transform: "translateY(-50%)",
                    width: "44px",
                    height: "44px",
                    borderRadius: "50%",
                    border: "none",
                    background: "rgba(0,0,0,0.6)",
                    color: "#fff",
                    fontSize: "20px",
                    cursor: "pointer",
                    zIndex: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  ›
                </button>
              </>
            )}
          </>
        )}
      </div>
    </section>
  );
};

export default HomepageVideoSlider;